import { type AxiosError } from 'axios'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { downloadAttachment } from '../../use-cases/downloadAttachment'

export function useDownloadAttachment() {
  const {
    call: handleDownload,
    result: attachmentURL,
    status: downloadStatus,
    error,
  } = useAsync(downloadAttachment)

  const abortController = useAbortController()

  const isLoading = downloadStatus === 'pending'

  function download(attachmentId: number, quoteUuid: string) {
    return handleDownload(
      {
        quoteUuid,
        attachmentId,
      },
      { signal: abortController.signal }
    )
  }

  return {
    download,
    attachmentURL,
    downloadStatus,
    error: error as AxiosError | undefined,
    isLoading,
  }
}
